<div
  class="divider-section"
  [class.full-width]="fullWidth"
  [style.margin-top]="marginTop"
  [style.margin-bottom]="marginBottom"
>
  <h3
    *ngIf="title"
    class="section-title"
    [style.border-bottom-color]="borderColor"
    [style.border-bottom-width]="borderWidth"
    [style.border-bottom-style]="'solid'"
    [style.padding-bottom]="paddingBottom"
    [style.font-size]="fontSize"
    [style.font-weight]="fontWeight"
    [style.text-align]="textAlign"
    [style.color]="titleColor"
  >
    {{ title | translate }}
  </h3>

  <div
    *ngIf="!title && showDivider"
    class="divider"
    [style.background-color]="borderColor"
    [style.height]="borderWidth"
  ></div>
</div>
